import React from 'react';

interface LogoIconProps {
  className?: string;
}

export const HubSpotIcon: React.FC<LogoIconProps> = ({ className = 'w-6 h-6' }) => (
  <img src="/hubspot-logo.svg" alt="" aria-hidden="true" className={className} />
);

export const StripeIcon: React.FC<LogoIconProps> = ({ className = 'w-6 h-6' }) => (
  <img src="/stripe-logo.svg" alt="" aria-hidden="true" className={className} />
);
